import { Box, Typography, FormControlLabel, Checkbox } from "@material-ui/core";
import { useTranslate } from "react-polyglot";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import { useChat } from "../../../../Providers/Data/ChatProvider.jsx";

const useStyles = makeStyles(() => ({
  root: {
    padding: 15,
    paddingBottom: 3,
    backgroundColor: "#F0EFEF",
    borderTopLeftRadius: 7,
  },
  noBorder: {
    border: "none",
    "& fieldset": {
      border: "none",
    },
  },
  marginBottom: {
    marginBottom: 7,
  },
}));

/** */
const ChatListHeader = () => {
  const classes = useStyles();
  const t = useTranslate();
  const { setUnreadFilter, unreadConversationsCount } = useChat();
  const [checked, setChecked] = useState(false);

  /** */
  const handleCheckbox = (event) => {
    setChecked(event.target.checked);
    setUnreadFilter(event.target.checked);
  };

  return (
    <Box className={classes.root}>
      <Typography className={classes.marginBottom} variant="h5">
        {t("chat.messages") + (unreadConversationsCount > 0 ? ` (${unreadConversationsCount})` : "")}
      </Typography>
      <FormControlLabel
        control={<Checkbox checked={checked} onChange={handleCheckbox} color="primary" />}
        label={t("chat.unreadOnly")}
      />
    </Box>
  );
};

export default ChatListHeader;
